import axios, { AxiosRequestConfig } from 'axios';

export interface ApiResponse {
    message: string;
    status: number;
    data?: any;
    meta?: {
        limit?: number;
        page?: number;
        total?: number;
        jwt?: string;
    };
}

export interface PaginatedCollection {
    items: Array<any>;
    perPage: number;
    currentPage: number;
    totalItems: number;
    totalItemsPO: number;
    totalItemsMeli: number;
    times?: Array<any>;
    message?: string
}

export const directusApi = (method: AxiosRequestConfig['method'], endpoint: string, data: any = {}) => {
    const url = `${process.env.VUE_APP_DIRECTUS_API_URL}/${endpoint}`;
    let headers: any = {};

    const access_token = window.localStorage.getItem(process.env.VUE_APP_DIRECTUS_ACCESS_TOKEN);
    if (access_token != null) {
        headers['Authorization'] = `Bearer ${access_token}`;
        headers['Content-Type'];
    }

    const options: AxiosRequestConfig = {
        method,
        url,
        data,
        headers,
    };

    return axios(options);
};
